<template functional>
  <div
    class="loader-container"
    :class="props.customClass"
  >
    <span
      class="loader"
      :class="props.loaderClass"
    />
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    customClass: {
      type: String,
      default: ''
    },
    loaderClass: {
      type: String,
      default: ''
    }
  },
};
</script>

<style>

</style>